import { Select } from 'antd';
import styled from 'styled-components';

export const FullWidthSelect = styled(Select)`
  width: 100%;
`;
